import { render } from "./course-enrollment.vue?vue&type=template&id=4df89eec"
import script from "./course-enrollment.vue?vue&type=script&lang=js"
export * from "./course-enrollment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__